import React from 'react';
import Post from "../Post";
import BodyContainer from "../../components/BodyContainer";
import {Link} from "react-router-dom";
import {cheapestPackage} from "../../components/CardWrapper/priceList";
import PostcodeApiVideo from "../../components/PostcodeApiVideo";

const PostcodeTabel = () => {
  return (
    <Post head={{
      title: 'Goedkoper alternatief voor postcodedatabase',
      description: 'Integreer adresvalidatie eenvoudig in je applicatie. Ontdek de voordelen van Postcode API, de standaard in adresvalidatie.'
    }}>
      <BodyContainer>
        <p>Adressen valideren binnen je website, CRM-systeem of app? Je kunt werken met een postcodetabel, maar Postcode
          API is vaak een betere oplossing.</p>
        <PostcodeApiVideo/>

        <h2 id="waarom-postcode-api-">Waarom? Postcode API…</h2>
        <ul>
          <li>biedt de data van de postcodetabel in de vorm van een API. Adressen en postbussen worden door de API snel
            ingevuld in je formulieren.
          </li>
          <li>zorgt ervoor dat de postcodedata automatisch dagelijks geactualiseerd wordt.</li>
          <li>verzorgt de hosting van deze data.</li>
          <li>is al vanaf {cheapestPackage.price.month} per maand te gebruiken.</li>
        </ul>
        <p><br/></p>
        <table>
          <thead>
          <tr>
            <th></th>
            <th style={{
              textAlign: 'center'
            }}>Postcodetabel</th>
            <th style={{
              textAlign: 'right'
            }}>Postcode API</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td><strong>Implementatie</strong></td>
            <td style={{
              textAlign: 'center'
            }}></td>
            <td style={{
              textAlign: 'right'
            }}></td>
          </tr>
          <tr>
            <td>Opzetten en inrichten</td>
            <td style={{
              textAlign: 'center'
            }}>x</td>
            <td style={{
              textAlign: 'right'
            }}>✓</td>
          </tr>
          <tr>
            <td>Automatisch onderhoud</td>
            <td style={{
              textAlign: 'center'
            }}>x</td>
            <td style={{
              textAlign: 'right'
            }}>✓</td>
          </tr>
          <tr>
            <td>Hosting</td>
            <td style={{
              textAlign: 'center'
            }}>x</td>
            <td style={{
              textAlign: 'right'
            }}>✓</td>
          </tr>
          <tr>
            <td><strong>Integratie &amp; Documentatie beschikbaar</strong></td>
            <td style={{
              textAlign: 'center'
            }}></td>
            <td style={{
              textAlign: 'right'
            }}></td>
          </tr>
          <tr>
            <td>PHP</td>
            <td style={{
              textAlign: 'center'
            }}>x</td>
            <td style={{
              textAlign: 'right'
            }}>✓</td>
          </tr>
          <tr>
            <td>Ruby</td>
            <td style={{
              textAlign: 'center'
            }}>x</td>
            <td style={{
              textAlign: 'right'
            }}>✓</td>
          </tr>
          <tr>
            <td>Symfony</td>
            <td style={{
              textAlign: 'center'
            }}>x</td>
            <td style={{
              textAlign: 'right'
            }}>✓</td>
          </tr>
          <tr>
            <td>Laravel</td>
            <td style={{
              textAlign: 'center'
            }}>x</td>
            <td style={{
              textAlign: 'right'
            }}>✓</td>
          </tr>
          <tr>
            <td>.NET</td>
            <td style={{
              textAlign: 'center'
            }}>x</td>
            <td style={{
              textAlign: 'right'
            }}>✓</td>
          </tr>
          <tr>
            <td><strong>Kosten</strong></td>
            <td style={{
              textAlign: 'center'
            }}></td>
            <td style={{
              textAlign: 'right'
            }}></td>
          </tr>
          <tr>
            <td>Kosten</td>
            <td style={{
              textAlign: 'center'
            }}>Vanaf € 2.915,-</td>
            <td style={{
              textAlign: 'right'
            }}>vanaf {cheapestPackage.price.month} per maand</td>
          </tr>
          <tr>
            <td>Kosten voor updates</td>
            <td style={{
              textAlign: 'center'
            }}>Vanaf €1.350,-</td>
            <td style={{
              textAlign: 'right'
            }}>n.v.t.</td>
          </tr>
          </tbody>
        </table>
        <h2 id="duizenden-klanten-ging-je-voor">Duizenden klanten ging je voor</h2>
        <p><img src="/assets/klanten.png" alt="Postcode API"
                title="Postcode API - goedkoper alternatief voor postcodetabel"/></p>
        <h2 id="klaar-om-postcode-api-te-gebruiken-">Klaar om Postcode API te gebruiken?</h2>
        <p><Link to="/prijzen/" className="button buttonCta">Registreer nu</Link></p>

      </BodyContainer>
    </Post>
  )
}

export default PostcodeTabel;
